import { useMemo } from 'react';
import useSWR from 'swr';
import { useSelector } from 'react-redux';
import { RootState } from '../../../state/store';
import { configureUrlWithParams } from '../../../helpers/utils';
import type { RevenueLeakageResponse } from '../types';

const useRevenueLeakageFilters = () => {
  const { company } = useSelector((state: RootState) => state);
  const filters = useSelector((state: RootState) => state.filters);

  return useMemo(() => {
    const locationIds = (filters.locations || []) as number[];
    const dates = filters.dates || ['', ''];
    const timeRange = filters.timeRange || [
      [0, 0],
      [0, 0]
    ];

    if (!locationIds.length || !dates[0] || !dates[1]) return null;

    return {
      locations: locationIds,
      dates,
      timeRange,
      widgets: [],
      shouldUseEpocForTimeRange: company.shouldUseEpocForTimeRange,
      timezoneOffset: company?.company_details?.time_zone_offset
    };
  }, [
    filters.locations,
    filters.dates,
    filters.timeRange,
    company.shouldUseEpocForTimeRange,
    company?.company_details?.time_zone_offset
  ]);
};

export const useRevenueLeakageSummary = () => {
  const filterParams = useRevenueLeakageFilters();
  const endpoint = useMemo(() => {
    if (!filterParams) return null;
    return configureUrlWithParams('/api/v1/revenue-leakage', filterParams);
  }, [filterParams]);

  return useSWR<RevenueLeakageResponse>(endpoint, {
    revalidateOnFocus: false
  });
};
